export function TableSearchHighlight({
  text,
  matcher
}: {
  text: string
  matcher: RegExp | undefined
}) {
  if (!matcher) return text

  return text.split(matcher).map((part, index) =>
    index % 2 === 1 ? (
      <mark key={index} className='bg-yellow-submarine text-inherit'>
        {part}
      </mark>
    ) : (
      part
    )
  )
}
